import { REFRESH_CACHE } from '../actions/appState'
import { LOGOUT, REGISTER_LOGIN } from '../actions/attendant'
import { ADD_TO_CART, UPDATE_CART_ITEM_QUANTITY } from '../actions/cart'
import {
  VNCATEGORIES_ADD_FAVORITE_ITEM,
  VNCATEGORIES_REMOVE_FAVORITE_ITEM,
  VNCATEGORIES_SET_CATEGORY_SEARCH,
  VNCATEGORIES_SET_SELECTED_CATEGORY,
  VNCATEGORIES_TOGGLE_FAVORITE_ITEM,
} from './ActionTypes'
import { ALL_ID, FAVORITES_ID } from './Selectors'

const getInitialState = () => ({
  selectedCategory: null,
  favoritesByMenuId: {},
  categorySearchterm: '',
})

const reducer = (state = getInitialState(), action) => {
  const { itemId, categoryId, menuId } = action || {}
  const lastUpdated = { [itemId]: { [categoryId]: new Date().toISOString() } }
  const curMenuFavorites = state.favoritesByMenuId?.[menuId]
  const curItem = curMenuFavorites?.[itemId] || []

  switch (action.type) {
    case VNCATEGORIES_TOGGLE_FAVORITE_ITEM:
    case VNCATEGORIES_ADD_FAVORITE_ITEM:
      if (!menuId) {
        return state
      }

      // add category to item that already exists
      return {
        ...state,
        lastUpdated,
        favoritesByMenuId: {
          ...state.favoritesByMenuId,
          [menuId]: {
            ...curMenuFavorites,
            [itemId]: [...curItem, categoryId],
          },
        },
      }
    case VNCATEGORIES_REMOVE_FAVORITE_ITEM:
      if (!menuId) {
        return state
      }

      // remove item from favorites
      if (!curItem?.includes(categoryId) && categoryId !== FAVORITES_ID) {
        return {
          ...state,
          lastUpdated: null,
        }
      }
      const favorites = {
        ...curMenuFavorites,
        [itemId]: curItem.filter((id) => id !== categoryId),
      }
      // when in favorites, remove item with all its categories
      if (categoryId === FAVORITES_ID) {
        delete favorites[itemId]
      }

      // if no categories left for item, remove it from favorites
      if (favorites[itemId]?.length === 0) {
        delete favorites[itemId]
      }

      // if no favorites left for menu, remove the menu
      if (Object.keys(favorites).length === 0) {
        const favoritesByMenuId = { ...state.favoritesByMenuId }
        delete favoritesByMenuId[menuId]
        return {
          ...state,
          favoritesByMenuId,
          lastUpdated: null,
        }
      }
      return {
        ...state,
        favoritesByMenuId: { ...state.favoritesByMenuId, [menuId]: favorites },
        lastUpdated: null,
      }
    case VNCATEGORIES_SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category,
        lastUpdated: null,
      }
    case REGISTER_LOGIN:
      if (Object.keys(state.favoritesByMenuId?.[action.payload?.menuId] || {})?.length) {
        return {
          ...state,
          selectedCategory: FAVORITES_ID,
          categorySearchterm: '',
        }
      }
      return {
        ...state,
        selectedCategory: ALL_ID,
        categorySearchterm: '',
      }
    case VNCATEGORIES_SET_CATEGORY_SEARCH:
      return {
        ...state,
        categorySearchterm: action.query,
      }
    // resets lastest updated when cart is updated
    // this prevents the "favorites" animation from showing
    case ADD_TO_CART:
    case UPDATE_CART_ITEM_QUANTITY:
      return {
        ...state,
        lastUpdated: null,
      }
    case REFRESH_CACHE:
    case LOGOUT:
      return {
        ...state,
        selectedCategory: null,
        categorySearchterm: '',
      }
    default:
      return state
  }
}

export default reducer
